// « Suivi(e) par Grâce Mbayo, Sami Wadido et 10 autres » — comptes que je suis qui suivent aussi cette personne
// (champ `mutual` {count, names ≤ 2} renvoyé par /users/{id}/followers|following et /users/suggestions).
export const mutualLabel = (m, t) => {
  const count = m?.count || 0;
  if (!count) return "";
  const names = (m.names || []).filter(Boolean);
  const [a, b] = names;
  if (!a) return t("profile.mutual_count", "Suivi(e) par {n} comptes que tu suis").replace("{n}", count);
  if (count === 1) return t("profile.mutual_one", "Suivi(e) par {a}").replace("{a}", a);
  if (!b) {
    return count === 2 ? t("profile.mutual_one_more_one", "Suivi(e) par {a} et 1 autre").replace("{a}", a)
      : t("profile.mutual_one_more", "Suivi(e) par {a} et {n} autres").replace("{a}", a).replace("{n}", count - 1);
  }
  if (count === 2) return t("profile.mutual_two", "Suivi(e) par {a} et {b}").replace("{a}", a).replace("{b}", b);
  if (count === 3) return t("profile.mutual_more_one", "Suivi(e) par {a}, {b} et 1 autre").replace("{a}", a).replace("{b}", b);
  return t("profile.mutual_more", "Suivi(e) par {a}, {b} et {n} autres").replace("{a}", a).replace("{b}", b).replace("{n}", count - 2);
};
